// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ke-0";
export var assigneeDetails = "_ke-1";
export var assigneeInfo = "_ke-2";
export var dropdownContainer = "_ke-4";
export var dropdownImage = "_ke-5";
export var editAssigneeInfo = "_ke-3";
export var editAssigneeModalContainer = "_ke-6";
export var hidden = "_ke-8";
export var input = "_ke-7";